
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freight-forwarder",
      function () {
        return require("private-next-pages/freight-forwarder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freight-forwarder"])
      });
    }
  